import { useAuth } from '@/contexts/AuthContext'

export function useAuthorization() {
  const { user } = useAuth()

  const role = (user?.role || '').toUpperCase()

  const hasRole = (required: string) => role === required.toUpperCase()
  const hasAnyRole = (roles: string[]) => roles.map((r) => r.toUpperCase()).includes(role)

  // Check if user has admin authority (only ROLE_ADMIN for user management)
  const isAdmin = user?.is_superuser || 
                  hasRole('ADMIN') || 
                  hasRole('ROLE_ADMIN') ||
                  (user?.authorities && user.authorities.includes('ROLE_ADMIN'))
  
  const isUser = hasRole('USER') || hasRole('ROLE_USER') || !!user

  // Can access the approval queue — admin or anyone explicitly given the
  // ROLE_USER_APPROVAL authority.
  const canApproveUsers =
    isAdmin ||
    (user?.authorities && user.authorities.includes('ROLE_USER_APPROVAL'))

  return { user, role, isAdmin, isUser, canApproveUsers, hasRole, hasAnyRole }
}


